import { upperCaseFirstLetter } from 'components/utils';

/**
 * Converts a given string to its canonical name format.
 * - Capitalizes the first letter of the string.
 * - For strings containing `.`, `-`, or `'`, capitalizes the first letter of each segment separated by these characters.
 *
 * @param str - The input string to be converted.
 * @returns The canonicalized name string.
 */
export function toCanonicalName(str: string): string {
    let result = upperCaseFirstLetter(str.toLowerCase());
    if (result.indexOf('.') !== -1 && result.length > 1) {
        result = result
            .split('.')
            .map(part => upperCaseFirstLetter(part))
            .join('.');
    }
    if (str.indexOf('-') !== -1 && result.length > 1) {
        result = result
            .split('-')
            .map(part => upperCaseFirstLetter(part))
            .join('-');
    }
    if (str.indexOf("'") !== -1 && result.length > 1) {
        result = result
            .split("'")
            .map(part => upperCaseFirstLetter(part))
            .join("'");
    }
    return result;
}
